module.exports = __webpack_public_path__ + "data/events.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/events/events.json
// module id = fxNh
// module chunks = 1